__turbopack_context__.v({
  "button": "BottomControllerReservation-module-scss-module__JPbXfq__button",
  "regular": "BottomControllerReservation-module-scss-module__JPbXfq__regular",
  "root": "BottomControllerReservation-module-scss-module__JPbXfq__root",
});
